import clsx from "clsx";
import { DetailedHTMLProps, ButtonHTMLAttributes, PropsWithChildren } from "react";

type SubTitleProps = DetailedHTMLProps<ButtonHTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement>

export function Subtitle({ children, className, ...headingProps }: PropsWithChildren<SubTitleProps>) {
    return <h2 className={clsx(className, "text-lg leading-5 font-medium text-secondary-950")} {...headingProps}>{children}</h2>;
}